import React from 'react'
import { MapCityMenu, MapFindMoreNonprofitsBtn, MapVideoPlayButton } from './subcomponents'

const MapNavUI = React.memo(() => {
    return (
        <div className='map-ui'>
            <div className="left">
                <MapCityMenu/>
            </div>

            <div className='right flex--center-y'>
                <MapFindMoreNonprofitsBtn/>
                <MapVideoPlayButton/>
            </div>

            <style jsx>{`
                .map-ui {
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 2;
                    width: 100%;
                }

                .left {
                    position: absolute;
                    left: 20px;
                    top: 20px;
                }

                .right {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                }

                .right :global(> div) {
                    margin-right: 12px;
                }
            `}</style>
        </div>
    )
})

export default MapNavUI